var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[(_vm.shouldShowProjectNav)?_c('ProjectNavbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }